import { State } from 'ducks/reducers'
import storeInfo from 'ducks/store'
import { UserType } from './types'
import { concatSeparator, EMAIL_TYPE, getNameFromAbb, USER_TYPE } from 'helpers'

export const getUser = (state: State): UserType => state.user

export const getUserId = (): string => {
  const { user } = storeInfo.store.getState()
  return user.id
}

export const getUserPrimaryEmail = (): string => {

  const { user } = storeInfo.store.getState()
  const primaryEmail =
    user?.email?.find((e) => e?.emailType === EMAIL_TYPE.PRIMARY)?.email ||
    user?.email?.[0]?.email || ""
  return primaryEmail || 'No email registered'
}

export const getUserFullName = (): string => {
  const { user } = storeInfo.store.getState()
  const { firstName, lastName } = user
  const fullName = concatSeparator(firstName, lastName, ' ')
  return fullName || 'No name registered'
}

export const getUserPhone = (): string => {
  const {
    user: { phone },
  } = storeInfo.store.getState()
  return phone?.toString() || 'No phone'
}

export const getUserAddress = (): string => {
  const { user } = storeInfo.store.getState()
  const { city, line_1: street1, line_2: unit, state, line1, line2 } = user.address
  const cityState = concatSeparator(city ?? '', state ?? '', ', ')
  const streetUnit = concatSeparator(street1 || line1 as string, unit || line2 as string, ', ')
  const address = concatSeparator(streetUnit ?? '', cityState ?? '', ', ')
  return address || 'No address'
}

export const getUserFullAddress = (): string => {
  const { user } = storeInfo.store.getState()
  const {
    line_1: street1,
    line_2: street2,
    line1,
    line2,
    city,
    state,
    zipCode,
  } = user.address
  // if (!street1 || !street2) return 'No address registered'
  let fullAddress = concatSeparator(street1 || line1 as string, street2 || line2 as string, ' ')
  fullAddress = concatSeparator(fullAddress, city, ', ')
  fullAddress = concatSeparator(fullAddress, getNameFromAbb(state), ', ')
  fullAddress = concatSeparator(fullAddress, zipCode, ', ')

  return fullAddress || 'No address registered'
}

export const getUserIsHomeowner = (): boolean => {
  const { user } = storeInfo.store.getState()
  return [USER_TYPE.HOMEOWNER, USER_TYPE.HOME_BUYER, USER_TYPE.HOME_SELLER, USER_TYPE.INSTITUTIONAL].includes(user?.clientType)
}
